<ng-content></ng-content>

<ng-container *ngFor="let key of keys[0], let i = index;">
  <td class="esf-table__cell"
      [attr.data-label]="columns[i]"
      [ngClass]="{'esf-table__cell--shrink vertical-middle': (isIcon(getData(key)) || isColor(getData(key))),
              'icon-table-padding': getCellType(getData(key)) === 'icon',
              'small-table-text': smallTable}">
    <ng-container [ngSwitch]="getCellType(getData(key))">
      <span class="esf-table__cell-inner" *ngSwitchCase="'date'">
        <span>
          {{ getData(key).date | date:getData(key).format}}
        </span>
      </span>

      <ng-container *ngSwitchCase="'array'">
        <span class="esf-table__cell-inner" *ngFor="let el of getData(key)">
          {{ el[keys[1][i]] }}
        </span>
      </ng-container>

      <span class="esf-table__cell-inner" *ngSwitchCase="'percentage'">{{ getData(key).value | percent:getData(key).format:locale}}</span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'currency'">{{ getData(key).value | currency:getData(key).currency:'code':undefined:locale}}</span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'status'">
        <a class="esf-tag" [ngClass]="getData(key).class + ' ' + getData(key).value">{{ getData(key).status }}</a>
      </span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'icon'">
        <button class="esf-button esf-button--simple black-color"
                [ngClass]="{'red-color': getData(key).value === '#esf-icon-pin', 'black-color': getData(key).value !== '#esf-icon-pin'}"
                [edsTooltip]="getData(key).tooltip">
          <svg class="esf-icon esf-button__icon" width="16" height="16" style="right: 0">
            <use [attr.xlink:href]="getData(key).value"></use>
          </svg>
          <span class="esf-button__icon-text"></span>
        </button>
      </span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'color'">
        <a class="esf-tag" [style.backgroundColor]="getData(key)" [ngClass]="{'text-color-dark': !isDark, 'text-color-light': isDark}"></a>
      </span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'colorTag'">
        <a class="esf-tag" [style.backgroundColor]="getData(key).color" [ngClass]="{'text-color-dark': !isDark, 'text-color-light': isDark}">{{ getData(key).text }}</a>
      </span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'badge'">
        <span class="esf-badge" [attr.data-badge]="getData(key).badgeValue">{{getData(key).text}}</span>
      </span>

      <span class="esf-table__cell-inner" *ngSwitchCase="'orderItem'">{{ getData(key) | evGroupOrderItems }}</span>


      <span class="esf-table__cell-inner" *ngSwitchCase="'string'" [innerHTML]="getData(key)">{{ getData(key) }}</span>
    </ng-container>
  </td>
</ng-container>

<ng-container *ngIf="actionButtons.length && rowData.type !== 'standard'">
  <td class="esf-table__cell esf-table__cell--shrink">
    <span class="esf-table__cell-inner" style="text-align: end;">
      <ng-container *ngFor="let actionButton of actionButtons">

        <ng-container *ngIf="actionButton.hideKey">
          <button [hidden]="checkDisabledActionButton(actionButton.hideKey)"
                  style="margin: 0 .6em"
                  [disabled]="checkDisabledActionButton(actionButton.disabled)"
                  class="esf-button esf-button--simple"
                  (click)="rowButtonClick(rowData, actionButton.type);$event.stopPropagation();"
                  [edsTooltip]="actionButton.tooltip">
            <svg class="esf-icon" width="16" height="16">
              <use [attr.xlink:href]="actionButton.icon"></use>
            </svg>
          </button>
        </ng-container>

        <ng-container *ngIf="!actionButton.hideKey">
          <button style="margin: 0 .6em"
                  class="esf-button esf-button--simple"
                  [disabled]="checkDisabledActionButton(actionButton.disabled)"
                  (click)="rowButtonClick(rowData, actionButton.type);$event.stopPropagation();"
                  [edsTooltip]="actionButton.tooltip">
            <svg class="esf-icon" width="16" height="16">
              <use [attr.xlink:href]="actionButton.icon"></use>
            </svg>
          </button>
        </ng-container>

      </ng-container>
    </span>
  </td>
</ng-container>
